import {configureStore} from '@reduxjs/toolkit'

import commonReducer from './slices/common.slice'
import profileReducer from './slices/profile.slice'
import accountReducer from './slices/account.slice'
import bankPaymentOrderReducer from './slices/bankpaymentorder.slice'
import calendarReducer from './slices/calendar.slice'
import taskCalendarReducer from './slices/task-calendar.slice'
import categoryReducer from './slices/category.slice'
import checkReducer from './slices/check.slice'
import checkoutReducer from './slices/checkout.slice'
import companyReducer from './slices/company.slice'
import expenseInvoiceReducer from './slices/expenseinvoice.slice'
import filtersReducer from './slices/filters.slice'
import digitalPlanetInvoiceReducer from './slices/digitalplanetinvoice.slice'
import digitalPlanetSettingsReducer from './slices/digitalplanetsettings.slice'
import edmInvoiceReducer from './slices/edminvoice.slice'
import edmSettingsReducer from './slices/edmsettings.slice'
import gibInvoiceReducer from './slices/gibinvoice.slice'
import guaranteeLetterReducer from './slices/guaranteeletter.slice'
import lookupReducer from './slices/lookup.slice'
import notificationReducer from './slices/notification.slice'
import officialReducer from './slices/official.slice'
import paymentPlanReducer from './slices/paymentplan.slice'
import paymentRequestReducer from './slices/paymentrequest.slice'
import productReducer from './slices/product.slice'
import projectReducer from './slices/project.slice'
import proposalReducer from './slices/proposal.slice'
import purchaseReducer from './slices/purchase.slice'
import reportingReducer from './slices/reporting.slice'
import saleInvoiceReducer from './slices/saleinvoice.slice'
import scorecardReducer from './slices/scorecard.slice'
import staffReducer from './slices/staff.slice'
import subcontractorDocumentReducer from './slices/subcontractordocument.slice'
import tenantCompanyReducer from './slices/tenantcompany.slice'
import userReducer from './slices/user.slice'
import userTaskReducer from './slices/usertask.slice'
import workplanReducer from './slices/workplan.slice'
import workstatusReducer from './slices/workstatus.slice'

export const store = configureStore({
  reducer: {
    common: commonReducer,
    profile: profileReducer,
    account: accountReducer,
    bankpaymentorder: bankPaymentOrderReducer,
    calendar: calendarReducer,
    taskCalendar: taskCalendarReducer,
    category: categoryReducer,
    check: checkReducer,
    checkout: checkoutReducer,
    company: companyReducer,
    expenseinvoice: expenseInvoiceReducer,
    filters: filtersReducer,
    digitalplanetinvoice: digitalPlanetInvoiceReducer,
    digitalplanetsettings: digitalPlanetSettingsReducer,
    edminvoice: edmInvoiceReducer,
    edmsettings: edmSettingsReducer,
    gibinvoice: gibInvoiceReducer,
    guaranteeletter: guaranteeLetterReducer,
    lookup: lookupReducer,
    notification: notificationReducer,
    official: officialReducer,
    paymentplan: paymentPlanReducer,
    paymentrequest: paymentRequestReducer,
    product: productReducer,
    project: projectReducer,
    proposal: proposalReducer,
    purchase: purchaseReducer,
    reporting: reportingReducer,
    saleinvoice: saleInvoiceReducer,
    scorecard: scorecardReducer,
    staff: staffReducer,
    subcontractorDocument: subcontractorDocumentReducer,
    tenantcompany: tenantCompanyReducer,
    user: userReducer,
    userTask: userTaskReducer,
    workplan: workplanReducer,
    workstatus: workstatusReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})
